import { render, staticRenderFns } from "./PersonReg1.vue?vue&type=template&id=4b0c94a1&scoped=true"
import script from "./PersonReg1.vue?vue&type=script&lang=js"
export * from "./PersonReg1.vue?vue&type=script&lang=js"
import style0 from "./PersonReg1.vue?vue&type=style&index=0&id=4b0c94a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c94a1",
  null
  
)

export default component.exports